import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserLandingsService {
  private TRIP_PLAN_ENDPOINT = '/chihiro/trip-plan';
  private OLD_TRIP_PLAN_ENDPOINT = '/nymeria-gui/data/model/removeUserLanding';

  constructor(@Inject(PLATFORM_ID) private platformId: string, private httpClient: HttpClient) { }

  deleteUserLanding<T>(id: string, isOldUserLanding: boolean): Observable<T> {
    const url = `${isOldUserLanding ? this.OLD_TRIP_PLAN_ENDPOINT : this.TRIP_PLAN_ENDPOINT}/${id}`;
    const headers: HttpHeaders = new HttpHeaders({
      ...this.getDefaultHeaders()
    });

    return this.httpClient.delete<T>(url, {
      observe: 'body',
      responseType: 'json',
      withCredentials: true,
      headers: headers,
    });
  }

  updateUserLanding<T>(id: string, body: any): Observable<T> {
    const url = `${this.TRIP_PLAN_ENDPOINT}/${id}`;
    const headers: HttpHeaders = new HttpHeaders({
      ...this.getDefaultHeaders()
    });

    return this.httpClient.patch<T>(url, body, {
      observe: 'body',
      responseType: 'json',
      withCredentials: true,
      headers: headers,
    });
  }

  private getDefaultHeaders(): { [key: string]: string } {
    if (isPlatformBrowser(this.platformId)) {
      return {
        'x-client': 'Nymeria',
      };
    }
    return {};
  }
}
